export default {

    methods: {


        pagesPlus: function () {
            if (!isNaN(this.pages)) {
                // Increment
                this.pages++
            } else {
                this.pages = 1
            }

        },
        wordsPlus: function () {
            if (!isNaN(this.words) && this.words >= 280) {
                // Increment
                this.words = +this.words + 50
            } else {
                this.words = 280
            }

        },

        pagesMinus: function () {
            if (!isNaN(this.pages) && this.pages > 1) {
                // Increment
                this.pages--
            } else {
                this.pages = 1
            }
        },

        wordsMinus: function () {
            if (!isNaN(this.words) && this.words > 280) {
                // Increment
                this.words = this.words - 50;
            } else {
                this.words = 280
            }
        },

        sourcesPlus: function () {
            if (!isNaN(this.sources)) {
                // Increment
                this.sources++
            } else {
                this.sources = 0
            }

        },

        sourcesMinus: function () {
            if (!isNaN(this.sources) && this.sources > 0) {
                // Increment
                this.sources--
            } else {
                this.sources = 0
            }
        },


    },

}